import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { SVGPureIcon } from '@/ui';
import { useMemo } from 'react';

const McpToolsBUStatus = observer((props) => {
  const {
    className = '',
    event,
  } = props;

  const message = useMemo(() => {
    try{
      const result = event.buResult.result;
      return `${result.desc || ''}${result.desc && result.content ? "： " : ""}${result.content || ''} ${result.desc2 || ''}`
    } catch(e){}

    return event.title || event.description;
  }, [event]);

  return (
    <div className={`tools-bu-status flex h-32px w-full rounded-12px items-center pl-10px pr-16px bg-[#F7F7F7] ${className}`} data-id={event.planStepId}>
      <SVGPureIcon name={`mcp_tool_view`} className='size-16px text-[#000000] flex-shrink-0' />
      <div className={`tools-bu-status-text text-13px leading-20px text-black text-opacity-70 ml-3px truncate text-black w-0 flex-grow truncate`}>
        {message}
      </div>
    </div>
  )
});
export default McpToolsBUStatus;